<template>
  <div class="col-4 pr-4">
    <div class="py-1 mb-0 bg-white pattern-2 tube_item-img">
      <RemoteResponsiveImage
        :product-image-data="item.ingredient.images[0]?.data"
        img-class="relative w-100 h-auto p-1 image-contain"
        :alt="item.ingredient.name"
        sizes="5vw"
      />
    </div>
  </div>
  <div class="col mr-auto">
    <p class="mb-0 ml-n2 small">
      <strong class="block mb-1 font-medium">
        {{ item.ingredient.name }}
      </strong>
      <span
        v-if="item.ingredient.parentCategoryId !== 'musli_base' && item.ingredient.parentCategoryId !== 'porridge_base'"
      >{{ item.amount }} x {{ item.ingredient.weight }} g</span>
    </p>
  </div>
  <ul class="col-4 pl-3 flex items-center justify-end self-start list-unstyled">
    <li class="ml-1 pt-1 relative">
      <ButtonMinus
        icon-size="12"
        add-class="px-2"
        @click="decreaseMixItem"
      />
    </li>
    <li
      v-if="!item.ingredient.isBase"
      class="ml-1 pt-1 relative"
    >
      <ButtonPlus
        :counter="item.amount"
        icon-size="12"
        add-class="px-2"
        @click="increaseMixItem"
      />
    </li>
  </ul>
</template>

<script setup>
import ButtonMinus from '@/components/buttons/ButtonMinus.vue'
import ButtonPlus from '@/components/buttons/ButtonPlus.vue'
import RemoteResponsiveImage from '@/components/general/BaseRemoteResponsiveImage.vue'
import { MixService } from '@/services/mixService'

const props = defineProps({
  kind: {
    type: String,
    required: true,
  },

  item: {
    type: Object,
    required: true,
  },
})

const increaseMixItem = () => {
  const mixService = new MixService(props.kind)
  mixService.addIngredient({ ingredient: props.item.ingredient, quantity: 1 })
}

const decreaseMixItem = () => {
  const mixService = new MixService(props.kind)
  mixService.removeIngredient({ ingredient: props.item.ingredient, quantity: 1 })
}
</script>

<style lang="scss">
.tube_item-img {
  height: 61px;
  padding-top: 4px !important;
}
</style>
